import * as React from "react";
const SvgFiRrRadioAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-radio-alt_svg__a)">
      <path
        fill="#062147"
        d="M19 6h-8.954l11.292-4.06A1 1 0 1 0 20.663.06L3.447 6.247A5.01 5.01 0 0 0 0 10.999v8c0 2.758 2.243 5 5 5h14c2.757 0 5-2.242 5-5v-8c0-2.756-2.243-5-5-5M5 8h14c1.304 0 2.415.836 2.828 2H2.172C2.464 9.177 3 8 5 8m14 14H5c-1.654 0-3-1.346-3-3v-7h20v7c0 1.654-1.346 3-3 3m-8-7a1 1 0 0 1-1 1H5a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1m0 4a1 1 0 0 1-1 1H5a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1m5.5-5.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5S20 18.93 20 17s-1.57-3.5-3.5-3.5m0 5c-.827 0-1.5-.674-1.5-1.5 0-.828.673-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .826-.673 1.5-1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-radio-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRadioAlt;
